// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Company, UserInfo, Freelancers, Contact, Invoices, Proposals, Quote, RecapInfo, QuoteInfo, Suppliers, Purchase, PurchaseOrder, Clients, Projects, CustomResolverStatusResponse, S3Object, InvoiceS3Object, Drafts, Discount, overtimeDetail } = initSchema(schema);

export {
  Company,
  UserInfo,
  Freelancers,
  Contact,
  Invoices,
  Proposals,
  Quote,
  RecapInfo,
  QuoteInfo,
  Suppliers,
  Purchase,
  PurchaseOrder,
  Clients,
  Projects,
  CustomResolverStatusResponse,
  S3Object,
  InvoiceS3Object,
  Drafts,
  Discount,
  overtimeDetail
};